<div class="auth-card">
  <!-- Logo -->
  <div class="auth-logo">
    <img src="assets/images/NBHA-Norway.png" alt="NBHA Norway" />
  </div>

  @if (verificationStatus === 'verifying') {
    <!-- Verifying State -->
    <div class="auth-header">
      <h1>Verifying email</h1>
      <p>Please wait while we verify your email</p>
    </div>

    <div class="alert alert-info">
      <i class="fa fa-spinner spinner"></i>
      <div>
        <strong>Verifying...</strong>
        <p class="mb-0">We're confirming your email address. This should only take a moment.</p>
      </div>
    </div>
  }

  @if (verificationStatus === 'success') {
    <!-- Success State -->
    <div class="auth-header">
      <h1>Email verified!</h1>
      <p>Your account is now active</p>
    </div>

    <div class="alert alert-success">
      <i class="fa fa-check-circle"></i>
      <div>
        <strong>Verification successful!</strong>
        <p class="mb-0">Your email has been verified. You will be redirected to your dashboard shortly...</p>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-primary"
      routerLink="/dashboard"
    >
      Go to dashboard
    </button>
  }

  @if (verificationStatus === 'error') {
    <!-- Error State -->
    <div class="auth-header">
      <h1>Verification failed</h1>
      <p>We couldn't verify your email</p>
    </div>

    <div class="alert alert-error">
      <i class="fa fa-exclamation-circle"></i>
      <div>
        <strong>Verification failed</strong>
        <p class="mb-0">{{ errorMessage || 'The verification link is invalid or has expired. Please request a new verification email.' }}</p>
      </div>
    </div>

    <!-- Divider -->
    <div class="auth-divider">
      <span>Need help?</span>
    </div>

    <!-- Actions -->
    <button
      type="button"
      class="btn btn-outline"
      routerLink="/auth/login"
    >
      <i class="fa fa-arrow-left me-2"></i>
      Back to login
    </button>
  }
</div>
